angular
    .module("skillBuilderSaaS")
    .directive("sbTextarea", function () {
    return {
        restrict: "E",
        require: ["ngModel"],
        templateUrl: "app/templates/sbTextareaTempate.html",
        scope: {
            ngModel: "=",
            maxlength: "=",
            placeholder: "@",
            rows: "=",
            spellcheck: "@"
        }
    };
});
